import $ from "jquery";

import {
  bindSearchDropdowns,
  bindDateInputs,
} from '../helper_modules/select2_form_helpers';

const searchFormElements = {
  dropdowns: $(`.search-box-field`),
  dateInputs: $(`.ship-by-end`),
};

export default class BulkShipmentSearchService {
  constructor() {
    this.searchFormElements = searchFormElements;
    this.bindElements();
  }

  static init() {
    if ($(`.bulk-shipments.index`).length === 0) {
      return;
    }

    return new BulkShipmentSearchService();
  }

  bindElements() {
    bindSearchDropdowns(this.searchFormElements);
    bindDateInputs(this.searchFormElements, {
      dateFormat: `mm-dd-yy`,
    });

    // When the date field is changed, mark the record as changed
    $(`.ship-by-end`).on(`change`, function() {
      $(this).parents(`tr`).find(`input.check[type=checkbox]`).click();
    });
  }
}
